import { styled, Badge as BadgeMui } from '@mui/material';

export const Badge = styled(BadgeMui)(() => ({
  '& .MuiBadge-badge': {
    margin: '3px 10px 0px 0px',
  },
}));

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  gap: 12,
  padding: '24px 0',
  position: 'relative',
}));

export const Greedy = styled('div')(() => ({
  flexGrow: 13,
}));
